import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * @typedef {object} ObservationReportViewPageRedirectorData
 * @property {number} [observationReportId]
 */

/**
 * @typedef {object} ObservationReportViewPageRedirectorProps
 * @property {ObservationReportViewPageRedirectorData} [data]
 */

/**
 * @param {ObservationReportViewPageRedirectorProps} props
 */
const ObservationReportViewPageRedirector = props => {
  const { data } = props;
  const { observationReportId } = data;
  return <Navigate to={`/observation-report/${observationReportId}`} />;
};

export default ObservationReportViewPageRedirector;
